// =====================================================
// COMPOSANT: DeltaPill — badge de variation N-1 réutilisable
// =====================================================
// Extrait le rendu du delta N-1 (vert/rouge/N-A + Δ absolu + Δ%) pour être
// partagé entre les cartes KPI globales et les cartes Flux d'entrées. Design
// system crm-4l (green/red sémantiques, zinc). Rendu identique à KpiCard RUN 1.

import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { DeltaValue } from '@/lib/dashboard-stats';

function fmt(n: number): string {
  return n.toLocaleString('fr-FR');
}

/** Formatte le Δ% : Infinity → « +100% », null → « N/A ». */
function fmtPct(pct: number | null): string {
  if (pct == null) return 'N/A';
  if (!isFinite(pct)) return '+100%';
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toFixed(1)}%`;
}

export function DeltaPill({ delta }: { delta: DeltaValue }) {
  if (delta.n1Unavailable) {
    return (
      <span className="inline-flex w-fit items-center gap-1 rounded-full border border-zinc-200 bg-zinc-50 px-2 py-0.5 text-xs font-medium text-zinc-500">
        <Minus className="h-3 w-3" />
        N/A vs N-1
      </span>
    );
  }
  const positive = (delta.deltaAbs ?? 0) >= 0;
  const DeltaIcon = positive ? TrendingUp : TrendingDown;
  return (
    <span
      className={[
        'inline-flex w-fit items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold tabular-nums',
        positive
          ? 'border-green-200 bg-green-50 text-green-700'
          : 'border-red-200 bg-red-50 text-red-700',
      ].join(' ')}
    >
      <DeltaIcon className="h-3 w-3" />
      {positive ? '+' : ''}
      {fmt(delta.deltaAbs ?? 0)}
      <span className="font-normal text-zinc-500">({fmtPct(delta.deltaPct)} N-1)</span>
    </span>
  );
}
